import {
  vArray,
  vDate,
  vEmail,
  vMaxLength,
  vNumber,
  vObject,
  vOptional,
  vOptionalDef,
  type vOutput,
  vPicklist,
  vPipe,
  vString,
} from '../validation/index.ts'
import { messageDeliveryStatuses } from './common.ts'

export const shareSchema = vObject({
  email: vEmail,
  updatedAt: vOptional(vDate()),
  role: vOptional(vPicklist(['share', 'origin', 'destination', 'stop'])),
  sequence: vOptional(vNumber()),
  status: vOptionalDef(
    vPicklist([...messageDeliveryStatuses, 'error']),
    'queued',
  ),
})

export const upsertShipmentShareSchema = vObject({
  documents: vArray(vString()),
  emails: vPipe(vArray(vEmail), vMaxLength(20)),
  message: vOptional(vString()),
})

export type UpsertShipmentShareDTO = vOutput<typeof upsertShipmentShareSchema>
